import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const before = ['Scrolling for an idea that might work', 'Not knowing what materials you’ll need', 'Finding a project that needs a special kit', 'Trying to explain unclear instructions', 'Watching excitement disappear before the build begins'];
const after = ['Choose a build by age, time, and challenge level', 'See the materials before you begin', 'Use simple household and recycled supplies', 'Follow clear visual build steps', 'Test, tweak, and celebrate a real finished creation'];
export function PainSection() {
  return <section className="w-full bg-ivory px-5 py-12 sm:py-20" data-id="element-134" data-mp="2bbzguzxew2z0">
      <div className="mx-auto max-w-5xl" data-id="element-135" data-mp="2gaaullqtuxmi">
        <div className="mx-auto max-w-2xl text-center" data-id="element-136" data-mp="2g76k66mrr5ne">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-navy sm:text-4xl" data-id="element-137" data-mp="22ajar4dmqn0l">
            Less “What can we do?” More “Look what I made!”
          </h2>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-138" data-mp="3rm98l2w66cum">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5
        }} className="rounded-2xl border-l-4 border-spark/50 bg-peach p-6 sm:p-8" data-id="element-139" data-mp="3rovgx4qvwwdw">
            <h3 className="mb-5 text-lg font-bold text-navy sm:text-xl" data-id="element-140" data-mp="38wj3nmyp0aoz">The usual activity hunt</h3>
            <ul className="space-y-3" data-id="element-141" data-mp="33xg9wyo5xqwb">
              {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-142" data-mp="33vda5mx7kjee">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-spark/15 text-spark-deep" data-id="element-143" data-mp="3in4c02464tl3">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-144" data-mp="3dtjd87ur3vku" />
                  </span>
                  <span className="text-sm leading-relaxed text-navy/80" data-id="element-145" data-mp="2q3yo17808234">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="rounded-2xl border-l-4 border-blue bg-blueprint p-6 sm:p-8" data-id="element-146" data-mp="p2r69rl89ev1">
            <h3 className="mb-5 text-lg font-bold text-blue-deep sm:text-xl" data-id="element-147" data-mp="12up6fcwyo0f2">
              With The Young Inventor Lab™
            </h3>
            <ul className="space-y-3" data-id="element-148" data-mp="b41786eul541">
              {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-149" data-mp="b658shp9xs15">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal/15 text-teal" data-id="element-150" data-mp="f4utywgk0dvc">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-151" data-mp="k2mkpn5gptxy" />
                  </span>
                  <span className="text-sm leading-relaxed text-navy/80" data-id="element-152" data-mp="1qmvxpxntxh7m">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}